// Unambiguous charset: no O/0, no I/1/l. Four characters rather than
// secret-hitler's three, for headroom and to make private rooms harder to
// stumble into by guessing.
const ROOM_CODE_CHARSET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
const ROOM_CODE_LENGTH = 4;
export function generateRoomCode(random = Math.random) {
    let code = '';
    for (let i = 0; i < ROOM_CODE_LENGTH; i++) {
        code += ROOM_CODE_CHARSET[Math.floor(random() * ROOM_CODE_CHARSET.length)];
    }
    return code;
}
export function isValidRoomCode(code) {
    if (code.length !== ROOM_CODE_LENGTH)
        return false;
    return [...code].every((c) => ROOM_CODE_CHARSET.includes(c));
}
export function normalizeRoomCode(code) {
    return code.toUpperCase().trim();
}
export { ROOM_CODE_CHARSET, ROOM_CODE_LENGTH };
